function initFilters() {
  const filtersMobileBtn = document.querySelector('.category__filters-mobile-btn');
  const filtersMobileClose = document.querySelector('.category__filters-mobile-close');
  const filters = document.querySelector('.category__filters');

  if (!filtersMobileBtn || !filters) return;

  filtersMobileBtn.addEventListener('click', () => {
    filters.classList.toggle('is-active');
  });

  filtersMobileClose.addEventListener('click', () => {
    filters.classList.remove('is-active');
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('.category__filters-mobile-btn')) return;
    if (e.target.closest('.category__filters-mobile-close')) return;
    if (e.target.closest('.category__filters-main')) return;
    filters.classList.remove('is-active');
  });
}

export { initFilters };